import CandidateCard from '@/app/2023/consejo/candidatos/components/CandidatesMesh/CandidateCard'
import SheetBase from '@/app/components/SheetBase'
import { normalNumberFormatter, percentFormatter } from '@/helpers/formatters'

import { IGanadorWithData } from '../../types/ganadores'

interface ICandidateSheet {
  className?: string
  candidato: IGanadorWithData
  onClose: () => void
}

const CandidateSheet = ({ candidato, className, onClose }: ICandidateSheet) => {
  return (
    <SheetBase
      candidato={candidato}
      className={className}
      onClose={onClose}
    >
      <CandidateCard
        {...candidato}
        cantidadVotos={normalNumberFormatter.format(candidato.votos)}
        mode="mobile"
        porcentajeVotos={percentFormatter.format(Number(candidato.porcentaje) || 0)}
      />
    </SheetBase>
  )
}

export default CandidateSheet
